import { z } from "zod";
import { ServiceTask } from "@opstel/query/v2/models/serviceTask";
import type { components } from "@opstel/gen/api/v2";
import { intervalSchema } from "./utils/dateTime";

export const serviceTaskSchema = z.object({
  type: z.string().min(1),
  timeInterval: intervalSchema,
  trackCode: z.string().min(1),
  trackName: z.string().min(1),
  arrivingTrainNumber: z.string().min(1),
  departingTrainNumber: z.string().min(1),
}) satisfies z.ZodType<ServiceTask, components["schemas"]["ServiceTask"]>;
